import Customer from '@sunbit-dev/common/models/ICustomer';

export interface State {
  customer: Partial<Customer>;
  mlaStatus: Mla;
  isLoggedIn: boolean;
  isFirstLogin: boolean;
  isSsnRequired: boolean;
  isInputCustomerDetailsMismatch: boolean;
}

export interface SetCustomerPayload {
  customer: Partial<Customer>;
}

export interface SetIsSsnRequiredPayload {
  isSsnRequired: boolean;
}

export interface SetIsInputCustomerDetailsMismatchPayload {
  isInputCustomerDetailsMismatch: boolean;
}

export enum Mla {
  Unknown,
  Allowed,
  NotAllowed,
}
